import { buildClassesHook } from '../../../helpers/styles';

export const useClasses = buildClassesHook({
    recurringBookingContainer: {
        display: 'flex',
        height: '100%',
        flexFlow: 'column nowrap',
    },
});
